<template>
    <div v-if="blok" v-editable="blok" class="relative overflow-hidden">
        <div class="swiper-container">
            <Swiper
                :modules="[Navigation]"
                :slides-per-view="1"
                :auto-height="true"
                :space-between="200"
                :navigation="{
                    prevEl: prevButton,
                    nextEl: nextButton,
                }"
                @swiper="updateNavigationColors"
                @slide-change="updateNavigationColors"
            >
                <SwiperSlide v-for="item in blok.items" :key="item._uid">
                    <BlockQuoteItem
                        :blok="item"
                        :navigation="blok.items.length > 1"
                    />
                </SwiperSlide>
            </Swiper>
            <div
                v-if="blok.items.length > 1"
                class="relative -top-20 flex h-0 justify-center gap-4 md:-top-24 lg:static lg:top-0"
            >
                <button
                    ref="prevButton"
                    type="button"
                    class="z-10 flex h-12 w-12 items-center justify-center rounded-full border transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none disabled:opacity-40 lg:absolute lg:top-1/2 lg:left-[77px] lg:-translate-y-1/2 xl:left-[109px]"
                    :class="navigationColor"
                >
                    <BaseIcon postnord-icon name="angle-small-left" />
                </button>
                <button
                    ref="nextButton"
                    type="button"
                    class="z-10 flex h-12 w-12 items-center justify-center rounded-full border transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none disabled:opacity-40 lg:absolute lg:top-1/2 lg:right-[77px] lg:-translate-y-1/2 xl:right-[109px]"
                    :class="navigationColor"
                >
                    <BaseIcon postnord-icon name="angle-small-right" />
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Swiper as SwiperType } from 'swiper';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { computed, ref } from 'vue';
import type { BlockQuotesStoryblok } from '~/app/types/storyblok-types';
import BaseIcon from '../ui/BaseIcon.vue';
import BlockQuoteItem from './BlockQuoteItem.vue';

const props = defineProps<{ blok: BlockQuotesStoryblok }>();

const prevButton = ref<HTMLElement | null>(null);
const nextButton = ref<HTMLElement | null>(null);
const backgroundColor = ref<string>('');
const navigationColor = computed(() =>
    backgroundColor.value === 'black'
        ? 'border-white text-white hover:bg-white hover:text-black'
        : 'border-black text-black hover:bg-black hover:text-white'
);

const updateNavigationColors = (swiper: SwiperType) => {
    backgroundColor.value =
        props.blok.items[swiper.realIndex]?.background_color ??
        backgroundColor.value;
};
</script>

<style>
@import 'swiper/css';
</style>
